export default __webpack_public_path__ + "static/media/6B.3ae6979e.png";